import React from "react";
import { SuperBlockContent } from "./super-block-content";

import "./grid.scss";
import classNames from "classnames";

interface Props {
  maxColumns?: number;
  style?: string;
  body?: any[];
}

export const Grid = ({ body, maxColumns, style }: Props) => {
  return (
    <SuperBlockContent
      projectId={"g3so7nt7"}
      dataset={"production"}
      className={classNames(
        "grid--container",
        `grid--container--colums-${maxColumns}`,
        {
          "grid--cards": style === "cards",
        },
      )}
      blocks={body}
    />
  );
};
